import { ArrowRight, Check, Mail, Send } from "lucide-react";

import type { DemoRole } from "./demo-api";

type Props = {
  roles: DemoRole[];
  role: DemoRole;
  sent: boolean;
  remaining: number | null;
  onSelectRole: (role: DemoRole) => void;
  onSend: () => void;
  onOpenInterview: () => void;
};

export const RecruiterSend = ({
  roles,
  role,
  sent,
  remaining,
  onSelectRole,
  onSend,
  onOpenInterview,
}: Props) => (
  <div className="a25-send">
    <div className="a25-panel a25-job">
      <fieldset className="a25-roles" disabled={sent}>
        <legend className="a25-label">Choose a role</legend>
        {roles.map((option) => (
          <label key={option.id} data-checked={option.id === role.id}>
            <input
              type="radio"
              name="a25-demo-role"
              value={option.id}
              checked={option.id === role.id}
              onChange={() => onSelectRole(option)}
            />
            <span className="a25-role-category">{option.category}</span>
            <span className="a25-role-title">{option.title}</span>
          </label>
        ))}
      </fieldset>

      <div className="a25-job-body">
        <p className="a25-label">Open role</p>
        <h3>{role.title}</h3>
        <p className="a25-job-meta">
          {role.company} · {role.location}
        </p>
        <p className="a25-job-summary">{role.summary}</p>
        <p className="a25-label">Must-haves</p>
        <ul className="a25-list">
          {role.mustHaves.map((item) => (
            <li key={item}>
              <Check size={14} aria-hidden="true" />
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>

    {sent ? (
      <div className="a25-panel a25-email" aria-live="polite">
        <div className="a25-email-head">
          <Mail size={16} aria-hidden="true" />
          <div>
            <p>
              <strong>From:</strong> {role.company} via Apex 25
            </p>
            <p>
              <strong>Subject:</strong> Your interview for {role.title}
            </p>
          </div>
        </div>
        <div className="a25-email-body">
          <p>Hi there,</p>
          <p>
            Thanks for applying for the {role.title} role at {role.company}. The next step is a
            short AI video interview with 3 questions. It takes about 2 minutes, and you can do it
            now.
          </p>
          <button
            type="button"
            className="btn a25-nudge"
            data-next-step=""
            onClick={onOpenInterview}
          >
            Start video interview <ArrowRight size={16} aria-hidden="true" />
          </button>
          <p className="a25-note">In this demo, you are the candidate. Nothing is emailed.</p>
        </div>
      </div>
    ) : (
      <div className="a25-panel a25-invite">
        <p className="a25-label">Interview questions</p>
        <ol className="a25-questions">
          {role.questions.map((question, index) => (
            <li key={question}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              {question}
            </li>
          ))}
        </ol>

        <p className="a25-label">Send to</p>
        <div className="a25-invitee">
          <span className="a25-avatar" aria-hidden="true">
            Y
          </span>
          <div>
            <strong>You</strong>
            <span>Shortlisted candidate</span>
          </div>
        </div>

        <div className="a25-invite-actions">
          <button type="button" className="btn a25-nudge" data-next-step="" onClick={onSend}>
            <Send size={15} aria-hidden="true" /> Send interview
          </button>
          <span className="a25-note">
            {remaining === null
              ? "2 free demo interviews per hour."
              : `${remaining} of 2 free demo interviews left this hour.`}
          </span>
        </div>
      </div>
    )}
  </div>
);
